<template>
	<div id="daumWrap" class="cafe_type3">
		<header id="daumHead" class="daum_head daum_head--fixed">
			<div class="cafe_head">
				<h1 class="sr_only">{{ grpname }}</h1>
				<div class="cafe_navi cafe_navi_type1 schedule_detail_header" id="cafe_navi_default">
					<h2 class="tit_day">{{ formattedDate }}</h2>
					<a :href="monthlyScheduleLink" class="link_close"><span class="ico_cafe ico_close">닫기</span></a>
				</div>
			</div>
		</header>
		<hr class="hide">
		<main id="daumContent" class="cont_schedule">
			<article id="mArticle">
				<div class="day_schedule" v-cloak>
					<h3 class="sr_only">상세일정</h3>
					<template v-if="schedules.length > 0">
						<schedule-item v-for="schedule in schedules" :key="schedule.scheduleId" :schedule="schedule" :calendar-id="calendarId" @delete="onDelete" :is-admin="isAdmin"></schedule-item>
					</template>
					<p class="schedule_empty" v-else>해당 일에 등록된 일정이 없습니다.</p>
				</div>
			</article>
		</main>
	</div>
</template>

<script>
import axios from 'axios';
import { parseISO, formatISO, format, addDays } from 'date-fns';
import ko from 'date-fns/locale/ko';

import {compare, isScheduleInDuration} from '@src/schedule/common';

import ScheduleItem from './components/ScheduleItem.vue';

const currentDate = parseISO(location.pathname.split('/')[3]);

export default {
	components: {
		ScheduleItem,
	},

	props: {
		isAdmin: Boolean,
		grpname: CAFEAPP.GRPNAME,

	},

	data() {
		return {
			schedules: [],
			calendarId: -1,
		};
	},

	computed: {
		monthlyScheduleLink() {
			return `/${CAFEAPP.GRPCODE}/${CAFEAPP.FLDID}?boardType=Q`;
		},

		formattedDate() {
			return format(currentDate, 'M월 d일 eeee', {
				locale: ko,
			});
		},
	},

	methods: {
		async onDelete(id) {
			this.schedules = this.schedules.filter((s) => s.scheduleId !== id);

			if (this.schedules.length === 0) {
				location.href = '/' + CAFEAPP.GRPCODE + '/' + CAFEAPP.FLDID + '?boardType=Q';
			}
		}
	},

	mounted() {
		const hashEl = document.getElementById(location.hash.substr(1));
		if (!hashEl) {
			return;
		}

		window.scroll(0, hashEl.offsetTop - 8);
	},

	async created() {
		const start = currentDate;
		const end = addDays(start, 1);

		const { data } = await axios.get(`/${CAFEAPP.GRPCODE}/${CAFEAPP.FLDID}/schedule`, {
			params: {
				startTime: formatISO(start),
				endTime: formatISO(end),
			},
		});

		this.schedules = data.data.scheduleList
			.filter(schedule => isScheduleInDuration(start, end, schedule))
			.sort(compare);

		this.calendarId = data.data.calendarId;

		sessionStorage.setItem('fromAnotherPage', 'true');
	},
}
</script>
